import { Fragment, h, render } from "preact";
import { useEffect, useState, useRef } from "preact/hooks";
import FullDetails from "../full-details.jsx";
import findCompatibleVariants from "../../helpers/findCompatibleVariants.js";
import stockMessage from "../../helpers/stock-message.js";
import SwatchImage from "../swatchImage.jsx";
import AnimatedCheckmark from "../animatedCheckmark.jsx";
import OptionValuePrice from "../optionValuePrice.jsx";
import QuantityInput from "../quantityInput.jsx";
import { isColor, findColorOptionName } from "../../helpers/colors.js";
import AliasedOption from "../aliased-option.jsx";

const DEFAULT_QUANTITY = 1;

const PopularAddonsConfiguration = ({ data, product, form, group }) => {
  const [selected, setSelected] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [variantForDefaultColor, setVariantForDefaultColor] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);

  let variants = product?.variants?.edges;

  const hasAliases = product?.variants.edges.some(
    (edge) => edge.node.variantAliases,
  );



  let { compatibleSizes, compatibleModels, firstColor } = data;

  const {
    compatibleVariants,
    updatedCompatibleSizes,
    updatedCompatibleModels,
  } = findCompatibleVariants({ variants, compatibleSizes, compatibleModels });

  variants = compatibleVariants;
  compatibleSizes = updatedCompatibleSizes;
  compatibleModels = updatedCompatibleModels;

  const colorOptionName = findColorOptionName(product?.options);

  const filteredOptions = product.options
    .filter((o) => {
      return o.name !== "Title";
    })
    .filter((o) => {
      return !(compatibleSizes.length && o.name === "Size");
    })
    .filter((o) => {
      return !(compatibleModels.length && o.name === "Model");
    })
    .map(({ name, values }) => {
      // Filter out option values that aren't included in compatible variants
      const availableValues = values.filter((value) => {
        return variants.some((variant) =>
          variant.node.selectedOptions.some(
            (option) => option.name === name && option.value === value,
          ),
        );
      });

      return { name, values: availableValues };
    });

  const colors = product.options.filter((o) => {
    return isColor(o.name);
  })[0];

  const options = product?.options?.filter(
    (option) =>
      !isColor(option.name) &&
      option.name != "Default Title" &&
      option.name != "Title",
  );
  let initialVariant = compatibleSizes.length
    ? variants.find((v) => {
        return compatibleSizes.includes(
          v?.node.selectedOptions?.find((element) => element.name == "Size")
            ?.value,
        );
      })?.node
    : variants[0]?.node;
  initialVariant = initialVariant ? initialVariant : variants[0]?.node;

  // Set Initial Variant Options
  let variantOptions = product?.options.map((edge, optionIndex) => ({
    [edge?.name]:
      hasAliases && optionIndex === options.length - 1
        ? null
        : initialVariant?.selectedOptions?.find(
            (element) => element.name == [edge?.name],
          ).value,
  }));


  const [variant, setVariant] = useState(initialVariant);
  const [quantity, setQuantity] = useState(DEFAULT_QUANTITY);
  const [selectedOptions, setSelectedOptions] = useState(variantOptions);

  if (product.handle == 'infant-car-seat-adapter') {
    console.log(`product`, product);
    console.log(`hasAliases`, hasAliases);
    console.log(`selectedOptions`, selectedOptions);
  }


  document.addEventListener("updateCart", (e) => {
    setSelected(false);
    setVariant(initialVariant);
    setQuantity(DEFAULT_QUANTITY);
  });

  useEffect(() => {
    const updateVariantForColor = (color) => {
      const variantMatchingColor = product.variants.edges.find(({ node }) =>
        node.selectedOptions.some(
          (option) => isColor(option.name) && option.value === color,
        ),
      );

      if (!variantMatchingColor) {
        setVariantForDefaultColor(null);
        return;
      }

      setVariantForDefaultColor(variantMatchingColor.node);
    };

    // Set for initial load
    updateVariantForColor(firstColor);

    const handleProductUpdate = (e) => {
      if (!colors) {
        setVariantForDefaultColor(null);
        return;
      }

      const color = e.detail.variant?.selectedOptions.find((option) =>
        isColor(option.name),
      )?.value;

      if (!color) {
        setVariantForDefaultColor(null);
        return;
      }

      updateVariantForColor(color);
    };

    document.addEventListener("productUpdate", handleProductUpdate);

    return () =>
      document.removeEventListener("productUpdate", handleProductUpdate);
  }, []);

  useEffect(() => {
    if (variantForDefaultColor && !selected) {
      setImageUrl(variantForDefaultColor?.image?.src);
      return;
    }

    if (variant) {
      setImageUrl(variant?.image?.src);
      return;
    }

    setImageUrl(product.images.edges[0].node.src);
  }, [selected, variantForDefaultColor, variant, product]);

  const handleColorVariants = () => {
    if (!colors) return;
    let so = Object.assign({}, ...selectedOptions);
    let vs = so
      ? variants.filter((v) => {
          let vo = product?.options.map((edge) => ({
            [edge?.name]: v?.node?.selectedOptions.find(
              (element) => element.name == [edge?.name],
            ).value,
          }));
          let voc = Object.assign({}, ...vo);
          return JSON.stringify(voc["Size"]) === JSON.stringify(so["Size"]);
        })
      : variants;
    return vs;
  };
  const [colorVariants, setColorVariants] = useState(handleColorVariants());

  useEffect(() => {
    setColorVariants(handleColorVariants());
  }, [selectedOptions]);

  const handleVariantChange = (option, val) => {
    let sv = null,
      svo = null,
      sp = null,
      optionMatch = false;
    if (val.node) {
      sp = val.node;
      sv = val.node.variants.edges[0].node;
      svo = val.node.variants.edges[0].node.selectedOptions;
    } else {
      const selectedOption = selectedOptions.map((o) => {
        if (Object.keys(o) == option) {
          return {
            ...o,
            [option]: val,
          };
        }
        return o;
      });

      optionMatch =
        JSON.stringify(selectedOption) == JSON.stringify(selectedOptions);

      const currentOption = {
        [option]: !optionMatch ? val : "",
      };

      if (optionMatch) {
        svo = selectedOptions.map((o) => {
          if (Object.keys(o) == option) {
            return {
              ...o,
              [option]: "",
            };
          }
          return o;
        });
        sv = variant;
      } else {
        let vset = variants;

        let selectedVariant = vset.filter((v) => {
          let vo = product?.options.map((edge) => ({
            [edge?.name]: v?.node?.selectedOptions.find(
              (element) => element.name == [edge?.name],
            ).value,
          }));
          return JSON.stringify(vo) === JSON.stringify(selectedOption);
        });

        if (!selectedVariant[0]?.node) {
          selectedVariant = vset.filter((v) => {
            let set = v?.node?.selectedOptions.find(
              (element) => element.name == [option] && element.value == [val],
            );
            return set?.value === currentOption[option];
          });
        }

        sv = selectedVariant.length > 0 ? selectedVariant[0] : selectedVariant;
        svo = sv.node.selectedOptions.map((option) => ({
          [option.name]: option.value,
        }));
        sv = sv.node ? sv.node : sv;
      }
    }
    setVariant(sv);
    setSelectedOptions(svo);
    setSelected(!optionMatch);
  };

  const handleVariantActive = (name, val) => {
    let vo = Object.assign({}, ...selectedOptions);
    return vo[name] == val ? "is-selected" : "";
  };

  // const findVariantAndHandleStock = ({ name, value }) => {
  //   const matchingVariants = variants.filter((variant) =>
  //     variant.node.selectedOptions.some(
  //       (option) => option.name === name && option.value === value,
  //     ),
  //   );

  //   if (matchingVariants.length > 1) return null;

  //   return stockMessage(matchingVariants[0].node);
  // };

  const findVariant = (name, value) => {
    const variant = variants
      // Find variants for selected 1st tier
      .filter(({ node }) => {
        const optionsWithMultipleValues = product.options.filter(
          (option) => option.optionValues.length > 1,
        );

        if (optionsWithMultipleValues.length === 1) return true;

        if (
          node.selectedOptions[0].value ===
          selectedOptions[0][node.selectedOptions[0].name]
        )
          return true;

        return false;
      })
      // Find variant for this option value
      .find(({ node }) =>
        node.selectedOptions.some(
          (option) => option.name === name && option.value === value,
        ),
      );

    if (!variant) return null;

    return variant.node;
  };

  const firstButHasOtherOptions = (name) => {
    const optionsWithMultipleValues = product.options.filter(
      (option) => option.optionValues.length > 1,
    );

    return (
      name === product.options[0].name && optionsWithMultipleValues.length > 1
    );
  };

  const findStockMessageFor = (name, value) => {
    // Don't display stock for 1st tier chips unless that is the only tier
    if (firstButHasOtherOptions(name)) {
      return null;
    }

    const variant = findVariant(name, value);

    if (!variant) return null;

    return stockMessage(variant);
  };

  const findVariantFor = (name, value) => {
    // Don't display price for 1st tier chips unless that is the only tier
    if (firstButHasOtherOptions(name)) {
      return null;
    }

    return findVariant(name, value);
  };

  const handleToggle = () => {
    if (selected) {
      setSelected(false);
      setQuantity(DEFAULT_QUANTITY);
      // setOpen(false);
    } else {
      setLoaded(true);
      setSelected(true);
      // setOpen(true);
      setSelectedOptions(variantOptions);
    }
  };

  const getPrice = (format = true) => {
    const price = variant?.priceV2?.amount
      ? variant?.priceV2?.amount
      : variant?.price;
    return format ? window.formatMoney(price) : price;
  };

  useEffect(() => {
    loaded && window.handleConfigPricing(variant, form);
  }, [selected, variant, quantity]);

  const selectedOptionValue = (name) => {
    let vo = Object.assign({}, ...selectedOptions);

    return vo[name] || null;
  };

  // This isn't playing nice with color selection in product-variant-content
  // so for now just pick color at the top level.
  // useEffect(() => {
  //   // Preselect any bundle products with an option matching
  //   // the requested color. ?color=Camo on the cruiser will select
  //   // a sidewall kit and a retractable canopy
  //   const { searchParams } = new URL(window.location);
  //   const param = searchParams.get("color");

  //   if (!param) return;

  //   const value = decodeURIComponent(param);
  //   const name = "Color";

  //   const matchingOption = product.options.find(
  //     (option) => option.name === name
  //   );

  //   if (!matchingOption || !matchingOption.values.includes(value)) return;

  //   handleVariantChange(name, value);
  //   handleOpen();
  // }, [product]);

  const singleOption =
    (filteredOptions.length > 0 && variants.length === 1) ||
    filteredOptions.length === 0;

  return (
    <div
      className={`popular-addons ${selected ? "popular-addons--selected" : ""}`}
      data-bundle-product={product.id}
    >
      {selected && (
        <Fragment>
          <input
            data-bundle-configuration-input
            data-quantity={quantity}
            type="hidden"
            name="id"
            value={variant.id.split("/").pop()}
          />
          <input
            data-bundle-configuration-price
            data-quantity={quantity}
            type="hidden"
            name="price"
            value={getPrice(false)}
          />
        </Fragment>
      )}
      <button
        className={`popular-addons__content${selected ? " is-selected" : ""}${
          selected ? " is-open" : ""
        }`}
        type="button"
        onClick={handleToggle}
      >
        <AnimatedCheckmark
          checked={selected}
          className="popular-addons__checkmark"
        />
        <div href={product.onlineStoreUrl} className="popular-addons__image">
          <img
            src={window.getSizedImageUrl(imageUrl, "x160")}
            alt={product.title}
            aria-hidden="true"
          />
        </div>
        <div className="popular-addons__text">
          <div className="popular-addons__title-wrapper">
            <div className="popular-addons__title">
              <span className="visually-hidden">
                {selected ? `Remove ${product.title}` : `Add ${product.title}`}
              </span>
              <span aria-hidden="true">{product.title}</span>
            </div>
            {variants?.length <= 1 && (
              <div className="popular-addons__availability" data-stock>
                {stockMessage(variant)}
              </div>
            )}
          </div>
          <div className="popular-addons__price-wrapper">
            <span className="popular-addons__price">{getPrice()}</span>
            {variant?.compareAtPriceV2?.amount &&
              parseFloat(variant?.compareAtPriceV2?.amount) >
                parseFloat(variant?.priceV2?.amount) && (
                <del className="popular-addons__compare-at-price">
                  {window.formatMoney(variant.compareAtPriceV2.amount)}
                </del>
              )}
          </div>
        </div>
      </button>
      <div className="popular-addons__content-variants">
        <div className="popular-addons__additional-details">
          <div className="popular-addons__additional-details-content">
            <FullDetails
              className="popular-addons__view-details"
              url={product.onlineStoreUrl}
              text="Full Details"
              tabindex={selected ? null : "-1"}
            />
            <QuantityInput
              quantity={quantity}
              setQuantity={setQuantity}
              tabindex={selected ? null : "-1"}
              productTitle={product.title}
            />
          </div>
        </div>
        {filteredOptions?.map(
          (option, index, arr) =>
            option.values.length > 1 &&
              hasAliases && index === arr.length - 1 ? (
                <AliasedOption
                  className="popular-addons__aliased-option"
                  product={product}
                  option={option}
                  selectedOptions={selectedOptions}
                  handleVariantChange={handleVariantChange}
                  active={selected}
                ></AliasedOption>
              ) : (!isColor(option?.name) && (
              <>
                <p class="popular-addons__content-selected-option">
                  <span className="popular-addons__content-selected-option-label">
                    Select a {option?.name}:
                  </span>
                  <span className="popular-addons__content-selected-option-value">
                    {selectedOptionValue(option?.name)}
                  </span>
                </p>
                <div
                  className={`popular-addons__options ${option?.name.toLowerCase()}`}
                >
                  {option.values?.map((item, i) => (
                    <button
                      tabindex={selected ? "0" : "-1"}
                      type="button"
                      className={`popular-addons__option ${handleVariantActive(
                        option?.name,
                        item,
                      )}`}
                      onClick={() => {
                        handleVariantChange(option?.name, item);
                      }}
                    >
                      <div className="popular-addons__option-text">
                        <span className="caption">{item}</span>
                        <span
                          className="popular-addons__option-availability"
                          data-stock
                        >
                          {findStockMessageFor(option?.name, item)}
                        </span>
                      </div>
                      <OptionValuePrice
                        variant={findVariantFor(option?.name, item)}
                        selectedVariant={variant?.node ? variant.node : variant}
                      />
                    </button>
                  ))}
                </div>
              </>
            ),)
        )}
        {colorVariants?.length > 1 && (
          <>
            <p class="popular-addons__content-selected-option">
              <span className="popular-addons__content-selected-option-label">
                Select a Color:
              </span>
              <span className="popular-addons__content-selected-option-value">
                {selectedOptionValue(colorOptionName)}
              </span>
            </p>
            <div
              className={`popular-addons__options ${colors?.name.toLowerCase()}`}
            >
              {colorVariants?.map((item, i) => (
                <button
                  tabindex={selected ? "0" : "-1"}
                  type="button"
                  className={`popular-addons__option ${handleVariantActive(
                    colorOptionName,
                    item.node.title.split(" / ").pop(),
                  )}`}
                  onClick={() => {
                    handleVariantChange(
                      colorOptionName,
                      item.node.title.split(" / ").pop(),
                    );
                  }}
                >
                  <SwatchImage
                    product={product}
                    handle={product?.handle}
                    optionValue={item?.node?.title.split(" / ").pop()}
                    className="popular-addons__option-image"
                  />
                  <div className="popular-addons__option-text">
                    <span className="caption">
                      {item.node.title.split(" / ").pop()}
                    </span>
                    <span
                      className="popular-addons__option-availability"
                      data-stock
                    >
                      {stockMessage(item.node)}
                    </span>
                  </div>
                  <OptionValuePrice
                    variant={item.node}
                    selectedVariant={variant?.node ? variant.node : variant}
                  />
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PopularAddonsConfiguration;
